import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'bcac-legend-toolbox',
  templateUrl: './bcac-legend-toolbox.component.html',
  styleUrls: ['./bcac-legend-toolbox.component.scss']
})
export class BcacLegendToolboxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  visible: boolean = false;
  closeDropDownMenu() {
    this.visible = false;
  }


  dropMenuPanelWidth = "12rem";
  @Input()
  set bcacDropMenuPanelWidth(value: string) {
    this.dropMenuPanelWidth = value;
  }

  selectValue = [];
  @Input()
  set bcacSelectValue(value: any[]) {
    this.selectValue = value;
  }

  @Output()
  bcacSelectValueEmit = new EventEmitter<any>();
  updateSelectValue() {
    this.bcacSelectValueEmit.emit(this.selectValue);
  }
  allChecked = false;
  indeterminate = true;
  updateAllChecked(): void {
    this.indeterminate = false;
    if (this.allChecked) {
      this.selectValue = this.selectValue.map(
        (item) => {
          return {
            ...item,
            checked: true,
          };
        }
      );
    } else {
      this.selectValue = this.selectValue.map(
        (item) => {
          return {
            ...item,
            checked: false,
          };
        }
      );
    }
    this.updateSelectValue();
  }

  updateSingleChecked(): void {
    if (this.selectValue.every((item) => !item.checked)) {
      this.allChecked = false;
      this.indeterminate = false;
    } else if (this.selectValue.every((item) => item.checked)) {
      this.allChecked = true;
      this.indeterminate = false;
    } else {
      this.indeterminate = true;
    }
    this.updateSelectValue();
  }
}
